module.exports = __webpack_public_path__ + "static/media/copy.bc00e88e.png";